import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/index';

export class ReservationByCountry extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'code',
    'country_name',
    'percentage',
    'reservations_count',
    'order',
)(ReservationByCountry);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/production/reservation-by-country.model.js